<div class="container-fluid">
    <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-grid-beat" [fullScreen]="true">
        <p style="color: white"> Please Wait, Registration In Process </p>
    </ngx-spinner>

    <!-- if payment_option is payment_gateway -->
    <mat-card *ngIf="payment_option == 'payment_gateway'" class="example-card">
        <mat-card-header class="justify-content-center">
            <mat-card-title class="title">
                <!-- <img class="event-logo" mat-card-image
                        src="https://aieventzo.com/upload/event_logo/{{event_logo}}" alt="Photo of a Shiba Inu"> -->
                Payment Page</mat-card-title>
        </mat-card-header>
        <img class="event-image" mat-card-image src="https://aieventzo.com/upload/event_image/{{event_image}}"
            alt="Photo of a Shiba Inu">
        <mat-card-content>
            <!-- <div *ngIf="event_id != 47"
                style="margin: 20px 0px;     font-size: clamp(1rem, 2.5vw, 1.5rem);
                padding: 15px; background-color: #F7EBD5; border-radius: 5px;display: flex; justify-content: center; align-items: center; text-align: center;">
                Registration Fee : &nbsp;
                <span style="font-weight: 700; color: #28762c;     font-size: clamp(1rem, 2.5vw, 1.5rem);
                ">
                    ₹{{reg_fee}} * {{allowed_person}} Persons
                </span>
            </div> -->
            <div class="row" *ngIf="showCouponCodeField">
                <!-- <mat-form-field appearance="outline">
                        <mat-label>Registration Fee</mat-label>
                        <input type="number" matInput placeholder="Registration Fee" [(ngModel)]="reg_fee"
                            [ngModelOptions]="{standalone: true}" required="true" readonly="true">
                    </mat-form-field> -->
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-label>Coupon Code</mat-label>
                    <input matInput placeholder="Coupon Code" (ngModelChange)="onCodeChange($event)"
                        [ngModel]="coupon_code" [ngModelOptions]="{standalone: true}">

                    <button matSuffix mat-raised-button color="primary" style="margin-right: 10px;
                        padding: 10px;
                        border-radius: 5px;
                        font-size: 16px;font-weight: 500;" (click)="get_coupon_code_by_code(coupon_code)"
                        *ngIf="apply != 'APPLIED'" [disabled]="!coupon_code || apply == 'APPLIED'">{{apply}} <mat-icon
                            *ngIf="apply == 'APPLIED'">check_circle</mat-icon></button>

                    <button matSuffix mat-button color="accent" style="margin-right: 10px;
                        padding: 10px;
                        border-radius: 5px;
                        font-size: 16px;font-weight: 500;" (click)="clearCode()" *ngIf="apply == 'APPLIED'">Remove
                    </button>
                </mat-form-field>
                <div *ngIf="!isValid" style="color: red;display: flex;gap:5px;">
                    <mat-icon>error</mat-icon>
                    <span>Invalid Coupon Code.</span>
                </div>
                <div *ngIf="isExpired" style="color: red;display: flex;gap:5px;">
                    <mat-icon>error</mat-icon>
                    <span>This Coupon Code has Expired.</span>
                </div>
            </div>

            <!-- Price Breakdown -->
            <div class="price-summary" *ngIf="pricingData">
                <h3 class="summary-title">Price Details</h3>

                <!-- Category -->
                <div class="summary-row highlight">
                    <strong>{{ tic_category[0]?.category }}</strong>
                    <span class="qty">Qty: {{ ticket_quantity }}</span>
                </div>

                <!-- Base Price -->
                <div class="summary-row">
                    <span>Base Price</span>
                    <span>
                        {{ pricingData.ticket_amount | currency:'INR':'symbol' }}
                    </span>
                </div>

                <!-- Convenience -->
                <div class="summary-row" style="padding-inline-start:30px;">
                    <span>
                        Convenience Charges
                        <small>
                            ({{ pricingData.convenience_fee }}%)
                        </small>
                    </span>
                    <span>
                        {{ pricingData.total_convenience_fee | currency:'INR':'symbol' }}
                    </span>
                </div>

                <!-- GST -->
                <!-- CGST -->
                <div class="summary-row" *ngIf="pricingData.cgst_per > 0 || pricingData.sgst_per > 0"
                    style="padding-inline-start:30px;">
                    <span>
                        CGST
                        <small>({{ pricingData.cgst_per }}%)</small>
                    </span>
                    <span>
                        {{ pricingData.cgst_amt | currency:'INR':'symbol' }}
                    </span>
                </div>

                <!-- SGST -->
                <div class="summary-row" *ngIf="pricingData.cgst_per > 0 || pricingData.sgst_per > 0"
                    style="padding-inline-start:30px;">
                    <span>
                        SGST
                        <small>({{ pricingData.sgst_per }}%)</small>
                    </span>
                    <span>
                        {{ pricingData.sgst_amt | currency:'INR':'symbol' }}
                    </span>
                </div>

                <div class="summary-row"
                    *ngIf="pricingData.igst_per > 0 && pricingData.cgst_per == 0 && pricingData.sgst_per == 0"
                    style="padding-inline-start:30px;">
                    <span>
                        IGST
                        <small>({{ pricingData.igst_per }}%)</small>
                    </span>
                    <span>
                        {{ pricingData.igst_amt | currency:'INR':'symbol' }}
                    </span>
                </div>

                <!-- Total Booking Fee -->
                <div class="summary-row">
                    <span>Total Booking Fee</span>
                    <span>
                        {{ pricingData.total_charges | currency:'INR':'symbol' }}
                    </span>
                </div>

                <div class="summary-row">
                    <span>Other Charges</span>
                    <span>
                        {{ pricingData.other_charges | currency:'INR':'symbol' }}
                    </span>
                </div>

                <!-- Subtotal -->
                <div class="summary-row">
                    <span>Subtotal</span>
                    <span>
                        {{ (pricingData.total_amount * ticket_quantity)
                        | currency:'INR':'symbol' }}
                    </span>
                </div>

                <!-- Coupon -->
                <div class="summary-row" *ngIf="apply === 'APPLIED'">
                    <span>
                        Coupon Discount
                        <small *ngIf="coupon_type === 'percentage'" style="color:#28762c;">
                            ({{ coupon_amount }}%)
                        </small>
                    </span>
                    <span style="color:#28762c;">
                        - {{ discount_amount | currency:'INR':'symbol' }}
                    </span>
                </div>

                <mat-divider></mat-divider>

                <!-- TOTAL -->
                <div class="summary-row total">
                    <span>TOTAL</span>
                    <span>
                        {{ payable_amount | currency:'INR':'symbol' }}
                    </span>
                </div>
            </div>



            <div style="margin: 20px 0px;     font-size: clamp(1rem, 2.5vw, 1.5rem);
            padding: 15px; background-color: #F7EBD5; border-radius: 5px;display: flex; justify-content: center;     font-weight: 600;
                align-items: center; text-align: center;">
                Net Amount : &nbsp;
                <span style="font-weight: 700; color: #28762c;     font-size: clamp(1rem, 2.5vw, 1.5rem);
                ">
                    ₹{{ payable_amount }}
                </span>
            </div>


            <mat-card-actions class=" d-flex justify-content-center mb-4">
                <button mat-raised-button style="background: #ffd740;font-size: 18px;font-weight: 600;"
                    (click)="pay()">PAY NOW</button>
            </mat-card-actions>

        </mat-card-content>

        <div style="display: flex;align-items: center;margin: 20px;">
            <div class="row">
                <div style="font-weight: 700;margin-right: 20px;">Download
                    Scan Me App :&nbsp;
                    <a href="https://play.google.com/store/apps/details?id=com.vthink.scanme">
                        <img width="25px" height="auto" src="./assets/playstore.png">
                    </a>
                    &nbsp;&nbsp;
                    <a href="https://apps.apple.com/in/app/aieventzo-event-tools/id6448720642">
                        <img width="25px" height="auto" src="./assets/apple.png">
                    </a>
                </div>
            </div>
        </div>
    </mat-card>

    <!-- if payment_option is qrcode -->
    <mat-card *ngIf="payment_option == 'qrcode'" class="example-card">
        <mat-card-header class="justify-content-center">
            <mat-card-title class="title">
                <!-- <img class="event-logo" mat-card-image
                            src="https://aieventzo.com/upload/event_logo/{{event_logo}}" alt="Photo of a Shiba Inu"> -->
                Payment Page</mat-card-title>
        </mat-card-header>
        <img class="event-image" mat-card-image src="https://aieventzo.com/upload/event_image/{{event_image}}"
            alt="Photo of a Shiba Inu">
        <mat-card-content>
            <div *ngIf="event_id != '19'"
                style="margin: 20px 0px;     font-size: clamp(1rem, 2.5vw, 1.5rem);
                    padding: 15px; background-color: #F7EBD5; border-radius: 5px;display: flex; justify-content: center; align-items: center; text-align: center;">
                Registration Fee : &nbsp;
                <span style="font-weight: 700; color: #28762c;     font-size: clamp(1rem, 2.5vw, 1.5rem);
                    ">
                    ₹{{reg_fee}} * {{allowed_person}} Persons
                </span>
            </div>

            <div class="row">
                <!-- <mat-form-field appearance="outline">
                        <mat-label>Registration Fee</mat-label>
                        <input type="number" matInput placeholder="Registration Fee" [(ngModel)]="reg_fee"
                            [ngModelOptions]="{standalone: true}" required="true" readonly="true">
                    </mat-form-field> -->
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-label>Coupon Code</mat-label>
                    <input matInput placeholder="Coupon Code" (ngModelChange)="onCodeChange($event)"
                        [ngModel]="coupon_code" [ngModelOptions]="{standalone: true}">

                    <button matSuffix mat-raised-button color="primary" style="margin-right: 10px;
                        padding: 10px;
                        border-radius: 5px;
                        font-size: 16px;font-weight: 500;" (click)="get_coupon_code_by_code(coupon_code)"
                        *ngIf="apply != 'APPLIED'" [disabled]="!coupon_code || apply == 'APPLIED'">{{apply}} <mat-icon
                            *ngIf="apply == 'APPLIED'">check_circle</mat-icon></button>

                    <button matSuffix mat-button color="accent" style="margin-right: 10px;
                        padding: 10px;
                        border-radius: 5px;
                        font-size: 16px;font-weight: 500;" (click)="clearCode()" *ngIf="apply == 'APPLIED'">Remove
                    </button>
                </mat-form-field>
                <div *ngIf="!isValid" style="color: red;display: flex;gap:5px;">
                    <mat-icon>error</mat-icon>
                    <span>Invalid Coupon Code.</span>
                </div>
                <div *ngIf="isExpired" style="color: red;display: flex;gap:5px;">
                    <mat-icon>error</mat-icon>
                    <span>This Coupon Code has Expired.</span>
                </div>
            </div>

            <div style="margin: 20px 0px;     font-size: clamp(1rem, 2.5vw, 1.5rem);
                padding: 15px; background-color: #F7EBD5; border-radius: 5px;display: flex; justify-content: center;     font-weight: 600;
                    align-items: center; text-align: center;">
                Net Amount : &nbsp;
                <span style="font-weight: 700; color: #28762c;     font-size: clamp(1rem, 2.5vw, 1.5rem);
                    ">
                    ₹{{payable_amount}}
                </span>
            </div>

            <div style="display: flex; justify-content: center; margin-top: 5px;">
                <canvas #canvas></canvas>
            </div>


            <mat-card-actions class=" d-flex justify-content-center mb-4">
                <button mat-raised-button style="background: #ffd740;font-size: 18px;font-weight: 600;"
                    (click)="completePayment()">PAYMENT RECEIVED <mat-icon>done</mat-icon></button>
            </mat-card-actions>

        </mat-card-content>

        <div style="display: flex;align-items: center;margin: 20px;">
            <div class="row">
                <div style="font-weight: 700;margin-right: 20px;">Download
                    Scan Me App :&nbsp;
                    <a href="https://play.google.com/store/apps/details?id=com.vthink.scanme">
                        <img width="25px" height="auto" src="./assets/playstore.png">
                    </a>
                    &nbsp;&nbsp;
                    <a href="https://apps.apple.com/in/app/aieventzo-event-tools/id6448720642">
                        <img width="25px" height="auto" src="./assets/apple.png">
                    </a>
                </div>
            </div>
        </div>
    </mat-card>
</div>
<footer class="bg-black text-white fixed-bottom">
    <div class="text-center">
        Event Ticketing by www.aieventzo.com
    </div>
</footer>